import { createTheme } from '@mui/material';
import { yellow, blue } from '@mui/material/colors';

export const LightTheme = createTheme({
  palette: {
    primary: {
      main: blue[700],
      dark: yellow[800],
      light: yellow[500],
      contrastText: '#ffffff',
    },
    background: {
      paper: '#ffffff',
      default: '#f7f6f3',
    },
  },
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(even)': {
            backgroundColor: '#c3c3c3', // zebrada
          },
          '&:nth-of-type(odd)': {
            backgroundColor: '#fff', // zebrada
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-root': {
            color: '#fff',
            fontWeight: 'bold',
            background: '#000090',
          },
        },
      },
    },
  },
});
